import { Component } from '@angular/core';
import {AuthenticationService, CTYPE } from '../../../services/authentication.service';
import {AppConfig} from '../../../app.config';

@Component({
  templateUrl: 'register.component.html'
})
export class RegisterComponent {

  private _email;

  private _password;

  private _repeatPassword;

  private _infoMessage;

  private _errorMessage;

  constructor(
    private authService: AuthenticationService
  ) { }

  public createAccount() {

    console.log('create account requested: ' + this._email + ' ' + this._password);


    if (!this.validateInput()) {
      return false;
    }

    this.sendCreateAccountRequest();
  }


  private validateInput(): boolean {

    if (!this._email) {
      this._errorMessage = 'Please enter your email';
      return false;
    }

    if (!this._password || !this._repeatPassword) {
      this._errorMessage = 'Please enter your password';
      return false;
    }

    if (this._password !== this._repeatPassword) {
      this._errorMessage = 'Passwords do not match';
      return false;
    }

    return true;
  }

  private sendCreateAccountRequest() {
    const request = this.authService.serializeObj({email: this._email, password: this._password})

    const options = this.authService.getDefaultReqOptions();
    options.headers = options.headers.set( 'Content-Type', CTYPE.FORM );
    this.authService.postUrlEncoded(AppConfig.UAA_URL + '/api/users', request)
      .subscribe({
        next: (response) => {
          console.log(response);
          this._infoMessage = 'Account has been created, please check email: ' + this._email;
          this._errorMessage = '';
        },
        error: (error) => {
          console.log('error: ' + error);
          this._infoMessage = '';
          this._errorMessage = 'An error has occurred. ' +
            'Make sure that account doesn\'t exist yet, or please provide valid email / password.';
        }
      })
  }


  get errorMessage() {
    return this._errorMessage;
  }

  get infoMessage() {
    return this._infoMessage;
  }


  get email() {
    return this._email;
  }

  set email(value) {
    this._email = value;
  }

  get password() {
    return this._password;
  }

  set password(value) {
    this._password = value;
  }

  get repeatPassword() {
    return this._repeatPassword;
  }

  set repeatPassword(value) {
    this._repeatPassword = value;
  }
}
